const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CampaignManagementQuery: any = {
    CampaignList: `${Backofficebff}/v1/campaignmanagement/getCampaigns`,
    MatrixList: `${Backofficebff}/v1/campaignmanagement/getMatrixList`,
    Campaign: `${Backofficebff}/v1/campaignmanagement/getCampaign`,
    AssigneeList: `${Backofficebff}/v1/campaignmanagement/getAssignees`,
    BadgeAssetList: `${Backofficebff}/v1/campaignmanagement/getBadgeAssets`,
    CouponList: `${Backofficebff}/v1/campaignmanagement/getCoupons`,
    Metadata: `${Backofficebff}/v1/campaignmanagement/getMetadata`,
    GetRulesByCampaignRuleId: `${Backofficebff}/v1/campaignmanagement/getRulesByCampaignRuleId`,
    DeleteRuleById: `${Backofficebff}/v1/campaignmanagement/deleteRule`,
    DeleteRuleConditionById: `${Backofficebff}/v1/campaignmanagement/deleteRuleCondition`,
    GetEarningsByCampaignRuleId: `${Backofficebff}/v1/campaignmanagement/getEarningsByCampaignRuleId`,
    GetEarningById: `${Backofficebff}/v1/campaignmanagement/getEarningById`,
    DeleteEarningById: `${Backofficebff}/v1/campaignmanagement/deleteEarning`,
    GetLogs: `${Backofficebff}/v1/campaignmanagement/getCampaignLogs`,
    GetAISuggestion: `${Backofficebff}/v1/campaignmanagement/GetAIDescriptionByCampaignRuleId`,
};
